<script>
    export let text = 'Title';
    export let infoHover;
    export let amount;
    export let isEmpty = false;

    export let color;

    let  displayAmount = isEmpty? '' : '' + amount;
</script>

<style>
    .wrapper {
        margin: 5% 10% 1%;
        /* overflow: hidden; */
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    }

    .blue {
        background: linear-gradient(111.72deg, #46D3FF -3.69%, #0487FF 106.42%);
    }

    .green {
        background: linear-gradient(126.15deg, #15DB70 -11.8%, #0A9452 104.01%);
    }

    .black {
        background: linear-gradient(126.15deg, #566573 -11.8%, #283747 104.01%);
    }

    .orange {
        background: linear-gradient(126.15deg, #FF7F50 -11.8%, #CB4335 104.01%);
    }

    h1 {
        font-family: Oswald;
        font-style: normal;
        font-size: 50px;
        line-height: 52px; 
        color: #FFFFFF;

        mix-blend-mode: normal;
        opacity: 0.9;

        flex-grow: 1;
    }

    h2 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 400;
        font-size: 24px;
        line-height: 52px;
        color: #FFFFFF;

        mix-blend-mode: normal;
        opacity: 0.9;
        margin: 0px 0px -5% 0PX;
    }


</style>

<svelte:head>
    <link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'>
    <link href='https://fonts.googleapis.com/css?family=Oswald' rel='stylesheet'>
</svelte:head>

<main>
    <div class="container {color}"> 
        <div class="wrapper">
            <h2> { text } </h2>
            <h1> { displayAmount } </h1>
        </div>
    </div>
</main>